<div class="dialog-header">
  <h1 mat-dialog-title translate="metric-reports/admin-user/currently-logged-export-tasks-details/title"></h1>
  <button mat-icon-button mat-dialog-close><mat-icon>close</mat-icon></button>
</div>

<mat-dialog-content>
  <table mat-table [dataSource]="dataSource" matSort matSortActive="id" matSortDirection="asc">
    <!-- ID Column -->
    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.id }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.id }}</span>
      </td>
    </ng-container>
    <!-- Date of receipt Column -->
    <ng-container matColumnDef="dateOfReceipt">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.dateOfReceipt }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.dateOfReceipt | dateTimezone: 'medium' }}</span>
      </td>
    </ng-container>
    <!-- Account Column -->
    <ng-container matColumnDef="account">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.account }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.account }}</span>
      </td>
    </ng-container>
    <!-- Channel Column -->
    <ng-container matColumnDef="channel">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.channel }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.channel }}</span>
      </td>
    </ng-container>
    <!-- Url Column -->
    <ng-container matColumnDef="url">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.url }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <a href="{{ row.url }}" target="_blank">{{ row.url }}</a>
      </td>
    </ng-container>
    <!-- Content Column -->
    <ng-container matColumnDef="content">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.content }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.content }}</span>
      </td>
    </ng-container>
    <!-- Author of message (id) Column -->
    <ng-container matColumnDef="authorId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.authorId }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.authorId }}</span>
      </td>
    </ng-container>
    <!-- Author of message (name) Column -->
    <ng-container matColumnDef="authorName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.authorName }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.authorName }}</span>
      </td>
    </ng-container>
    <!-- Date of Display Column -->
    <ng-container matColumnDef="dateOfDisplay">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.dateOfDisplay }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.dateOfDisplay | dateTimezone: 'medium' }}</span>
      </td>
    </ng-container>
    <!-- Team Column -->
    <ng-container matColumnDef="team">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <span>{{ headers.team }}</span>
      </th>
      <td mat-cell *matCellDef="let row">
        <span>{{ row.team }}</span>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button type="button" mat-dialog-close><span translate="close"></span></button>
  <button mat-raised-button type="button" color="primary" (click)="export()">
    <span translate="metric-reports/admin-user/export"></span>
  </button>
</mat-dialog-actions>
